import React from 'react';
import logo from '../assets/logo.png';
import './LoadingScreen.css';

export default function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <img src={logo} alt="Hangrily" className="loading-logo-image" />
        <div className="spinner"></div>
        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
}
